import React, { useState } from 'react';
import './App.scss';

import IMG2 from "../../assets/IMG-2.jpg";
import IMG3 from "../../assets/IMG-3.png";
import IMG4 from "../../assets/IMG-4.png";
import IMG5 from "../../assets/capital.png";
import IMG6 from "../../assets/green-page.png";
import IMG7 from "../../assets/IMG-7.png";
import IMG8 from "../../assets/meal-plan.png";
import IMG9 from "../../assets/scholl.png";
import IMG10 from "../../assets/devscholl.png";
import IMG11 from "../../assets/web-nlw-art.png";
import IMG12 from "../../assets/nlw-apps.png";
import IMG13 from "../../assets/pokedex.png";
import IMG14 from "../../assets/listTel.png";
import IMG15 from "../../assets/mb-app.png";
import IMG16 from "../../assets/react-blueprint.png";
import IMG17 from "../../assets/pecazap.png";
import IMG18 from "../../assets/vidya.png";

function Projects() {
  const [projects] = useState([
    {
      id: 14,
      image: IMG17,
      title: "[React] PecaZap - Vulcanet",
      github: "https://pecazap.com.br/",
      demo: "https://pecazap.com.br/",
    },
    {
      id: 15,
      image: IMG18,
      title: "[Vue, Java] Vidyatec.ai",
      github: "https://vidyatec.com/software/",
      demo: "https://vidyatec.com/software/",
    },
    // {
    //   id: 0,
    //   image: IMG7,
    //   title: "Portfolio 2023",
    //   github: "https://github.com/luiz-cazarin/react-portfolio",
    //   demo: "https://react-portfolio-ee3c7.web.app/",
    // },
    {
      id: 1,
      image: IMG2,
      title: "Real-time Strategy Game",
      github: "https://github.com/luiz-cazarin/Jogo-Estrategia-em-Tempo-Real",
      demo: "https://github.com/luiz-cazarin/Jogo-Estrategia-em-Tempo-Real",
    },
    {
      id: 2,
      image: IMG3,
      title: "Delivery App",
      github: "https://github.com/luiz-cazarin/delivery-app",
      demo: "https://github.com/luiz-cazarin/delivery-app",
    },
    {
      id: 3,
      image: IMG4,
      title: "Devlearing Web Site",
      github: "https://github.com/luiz-cazarin/devlearning",
      demo: "https://devlearning-teal.vercel.app/",
    },
    {
      id: 12,
      image: IMG15,
      title: "[ReactNative] MB Ticket Sales",
      github: "https://github.com/luiz-cazarin/MB-ReactNative-App-Eventos",
      demo: "https://github.com/luiz-cazarin/MB-ReactNative-App-Eventos",
    },
    {
      id: 4,
      image: IMG5,
      title: "[Vue] Capital Construções ",
      github: "https://github.com/luiz-cazarin/capitalConstrucoes",
      demo: "https://capital-construcoes.vercel.app/#/",
    },
    {
      id: 5,
      image: IMG6,
      title: "[VUE] CazaDEV",
      github: "https://github.com/luiz-cazarin/cazadev",
      demo: "https://cazadev.vercel.app/#/",
    },
    {
      id: 5,
      image: IMG8,
      title: "[VUE] Plano alimentar",
      github: "https://meal-plan-red.vercel.app/#/",
      demo: "https://meal-plan-red.vercel.app/#/",
    },
    // {
    //   id: 6,
    //   image: IMG9,
    //   title: "[Vuetify] Crud",
    //   github: "https://github.com/luiz-cazarin/school-vuetify",
    //   demo: "https://school-vuetify.vercel.app/#/",
    // },
    // {
    //   id: 7,
    //   image: IMG10,
    //   title: "[Quasar] DEVScholl",
    //   github: "https://github.com/luiz-cazarin/DEVScholl",
    //   demo: "https://github.com/luiz-cazarin/DEVScholl",
    // },
    // {
    //   id: 8,
    //   image: IMG11,
    //   title: "[React] NLW WEB Esports",
    //   github: "https://github.com/luiz-cazarin/nlw-2022-web",
    //   demo: "https://github.com/luiz-cazarin/nlw-2022-web",
    // },
    // {
    //   id: 9,
    //   image: IMG12,
    //   title: "[ReactNative] NLW APP Esports",
    //   github: "https://github.com/luiz-cazarin/nlw-2022-mobile-ReactNative",
    //   demo: "https://github.com/luiz-cazarin/nlw-2022-mobile-ReactNative",
    // },
    // {
    //   id: 10,
    //   image: IMG13,
    //   title: "[Vue] Pokedex",
    //   github: "https://github.com/luiz-cazarin/Vue-Pokedex",
    //   demo: "https://vue-pokedex-orpin.vercel.app/",
    // },
    // {
    //   id: 11,
    //   image: IMG14,
    //   title: "[Quasar] Lista telefonica",
    //   github: "https://github.com/luiz-cazarin/Vue---Quasar-UMD-CRUD",
    //   demo: "https://github.com/luiz-cazarin/Vue---Quasar-UMD-CRUD",
    // },
    // {
    //   id: 13,
    //   image: IMG16,
    //   title: "[React] React challenge - Blueprint",
    //   github: "https://github.com/luiz-cazarin/react-challenge-blueprint",
    //   demo: "https://react-challenge-blueprint.vercel.app/",
    // },

  ]);

  return (
    <>
      <div className='title-box'>
        <p className='subtitle'>Projects Developed</p>
        <p className='title'>Projetos</p>
      </div>
      <div className='projects'>
        {projects.map((el) => (
          <div className='card-project'>
            <div className='header'>
              <div className='icons'>
                <div className='icon-1'></div><div className='icon-2'></div><div className='icon-3'></div>
              </div>
              <p className='title'>{el.title}</p>
              <div className='icons' />
            </div>
            <div className='card'>
              <img src={el.image} alt='dev' />
            </div>
            <div className='actions'>
              <a className='primary' href={el.github} target="_blank">Github</a>
              <a className='secondary' href={el.demo} target="_blank">Live Demo</a>
            </div>
          </div>
        ))}
      </div>
    </>
  );
}

export default Projects;
